function useScrollLocker(id) {
  const lock = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.textContent = "html body {overflow-y: hidden}";
    style.setAttribute("lock-id", `lock-id-${id}`);
    document.head.appendChild(style);
  };
  const unlock = () => {
    const style = document.querySelectorAll(`[lock-id="lock-id-${id}"]`)[0];
    if (style) {
      style.parentNode.removeChild(style);
    }
  };
  return {
    lock,
    unlock
  };
}
export {
  useScrollLocker
};
//# sourceMappingURL=useScrollLocker.es.js.map
